const handleSaveLocation = async (user_id, bot_id, data) => {
  try {
    const uri = `${process.env.REACT_APP_SERVER}/other/saveLocation`;
    const visitorId = localStorage.getItem("visitor_id");

    if (!visitorId) {
      console.error("Visitor ID not found in localStorage");
      alert("Visitor ID is missing!");
      return;
    }

    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        visitor_id: visitorId,
        bot_id,
        user_id,
        ...data,
      }),
    };

    const res = await fetch(uri, options);

    if (!res.ok) {
      throw new Error(`Failed to update: ${res.status} ${res.statusText}`);
    }
  } catch (error) {
    console.error("Error updating location:", error);
  }
};

export default handleSaveLocation;
